/* import __COLOCATED_TEMPLATE__ from './test-as-selector-inline.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent-2 */

import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';
import { getTestingAsLabel } from './helpers';

export interface Args {
  displayUser?: any;
  playgroundApi?: any;
  audienceSegments?: any[];
  onOpenUserSearch: () => void;
  onOpenAudienceSearch: () => void;
  onSelectPreviewUser: () => void;
}

interface Signature {
  Element: HTMLDivElement;
  Args: Args;
}

export default class TestAsSelectorInline extends Component<Signature> {
  @service declare intl: IntlService;
  get isPreviewUserSelected() {
    return !this.args.playgroundApi?.selectedContentSegmentIds?.length && !this.args.displayUser;
  }

  get isSpecificUserSelected() {
    return (
      !this.args.playgroundApi?.selectedContentSegmentIds?.length && Boolean(this.args.displayUser)
    );
  }

  get isAudienceSelected() {
    return Boolean(this.args.playgroundApi?.selectedContentSegmentIds?.length);
  }

  get testingAsIcon() {
    return this.isAudienceSelected ? 'multiple-people' : 'user-id';
  }

  get testingAsLabel() {
    return getTestingAsLabel({
      playgroundApi: this.args.playgroundApi,
      audienceSegments: this.args.audienceSegments || [],
      intl: this.intl,
    });
  }

  @action
  selectUserOrLead(): void {
    // Opens user search modal directly
    this.args.onOpenUserSearch();
  }

  @action
  selectAudience(): void {
    // Opens audience search modal directly
    this.args.onOpenAudienceSearch();
  }

  @action
  selectPreviewUser(): void {
    // If switching from a selected user or audience, trigger confirmation flow
    // If already preview user, no action needed
    if (this.isSpecificUserSelected || this.isAudienceSelected) {
      this.args.onSelectPreviewUser();
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::Playground::Settings::TestAsSelectorInline': typeof TestAsSelectorInline;
    'ai-agent/playground/settings/test-as-selector-inline': typeof TestAsSelectorInline;
  }
}
